import Block from 'components/Block'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import { View } from 'components/View'
import React from 'react'
import {
  defineMessages,
  useIntl
} from 'react-intl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import PageSubTitle from 'components/Page/Page.SubTitle.js'
import PropTypes from 'prop-types'

const messages = defineMessages({
  getAppTitle: {
    id: 'GetApp.getAppTitle',
    defaultMessage: 'Ready to Try Gymaholic Free?'
  }
})

export function GetApp ({
  descriptionMessage,
  ctaComponent
}) {
  const intl = useIntl()

  return (
    <Block
      style={{
        textAlign: 'center'
      }}
      bgc='backgroundContent'
    >
      <View
        ac
        jc
      >
        <TextTitleCompressedHeavy>
          {formatMessageIntlUtil(intl, messages.getAppTitle)}
        </TextTitleCompressedHeavy>

        <PageSubTitle>
          {formatMessageIntlUtil(intl, descriptionMessage)}
        </PageSubTitle>

        {ctaComponent}
      </View>
    </Block>
  )
}

GetApp.propTypes = {
  descriptionMessage: PropTypes.object.isRequired,
  ctaComponent: PropTypes.node.isRequired
}
